module.exports = __webpack_public_path__ + "img/table-4.7003313a.jpg";